<template>
  <v-sheet tile class="fill-height">
    <v-container align="center" class="store_details_container">
      <div class="primary-gradient-background">
        <div class="avatar large">
          <SpotS3Image :image-path="brand.image"></SpotS3Image>
        </div>
        <div class="brand-title">
          <span>{{brand.name}}</span>
        </div>
        <div class="action-btns">
          <v-btn :loading="loadingState" small rounded outlined color="white"
                 :to="{name:PAGE_IDS.STORE_EDIT, params:{store_id:store.id}}">
            <v-icon>edit</v-icon>
            Edit
          </v-btn>
          <v-btn :loading="loadingState" v-if="isBrandManagerOfStore(store.id)" small rounded outlined color="white"
                 @click.native.prevent="deleteStore">
            <v-icon>delete</v-icon>
            Delete
          </v-btn>
        </div>
      </div>
      <v-spacer style="height:236px"></v-spacer>
      <v-list class="pa-0">
        <v-list-item class="pa-0">
          <v-list-item-icon>
            <v-icon color="primary">location_on</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{store.address}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>
        <v-list-item class="pa-0">
          <v-list-item-icon>
            <v-icon color="primary">phone</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{store.phone}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>
      </v-list>
      <UsersList class="user-list" :caption="brand.store_manager_role_title" :empty_text="no_manager_text"
                 :users="store.storemanagers"
                 v-on:updateUsers="updateStoreManagers"></UsersList>
      <UsersList class="user-list" :caption="brand.security_role_title" :empty_text="no_security_text"
                 :users="store.security"
                 v-on:updateUsers="updateStoreSecurity"></UsersList>
      <div class="general_details">
        <div class="title">
          <div class="black--text clarification">
            <div>
              Store Preferences
            </div>
            <FullscreenModalWithSlot :dense="true" @opened="toggleOverlay" @closed="toggleOverlay">
              <template v-slot:activator>
                <v-icon color="primary" style="opacity: .6;cursor: pointer">help</v-icon>
              </template>
              <template v-slot:content>
                <div class="pa-5">
                  <div class="single-clarification mb-5" v-for="clarification in clarifications_list">
                    <div class="clarification-title font-weight-bold">
                      {{clarification.title}}
                    </div>
                    <div class="clarification-text ">
                      {{clarification.text}}
                    </div>
                  </div>
                </div>
              </template>
            </FullscreenModalWithSlot>
          </div>

        </div>
        <div>
          <div>
            <span>Max Visitors: </span>
            <span class="general_info_val">{{store.num_persons}}</span>
          </div>
          <span>Visit Duration: </span>
          <span class="general_info_val">{{store.duration}} minutes</span>
        </div>

        <div>
          <span>Automated Exit: </span>
          <span class="general_info_val">{{store.minutes_before_out}} minutes</span>
        </div>
        <div>
          <span>Code Expiration: </span>
          <span class="general_info_val">{{store.minutes_before_expire}} minutes</span>
        </div>
        <div>
          <span>Timezone: </span>
          <span class="general_info_val">{{getTimezoneNameByValue}}</span>
        </div>
      </div>
      <StoreOpenTable :store="store"/>
      <v-spacer style="margin-top: 60vh"></v-spacer>
      <FullScreenMap :store="store"/>
      <v-overlay v-model="overlay"></v-overlay>
    </v-container>
  </v-sheet>
</template>


<script>
  import {mapGetters} from "vuex";
  import StoreTile from "./StoreTile";
  import {UsersList} from "../Users";
  import {doUpdateStore} from "../graphql/mutations";
  import {process_api_error} from "@/utils/utils"
  import StoreOpenTable from "../Elements/StoreOpenTable";
  import SpotS3Image from "../Pages/SpotS3Image";
  import {doDeleteStore} from "../graphql/mutations";
  import {PAGE_IDS} from "../utils/constants"
  import FullScreenMap from "../Elements/FullScreenMap";
  import FullscreenModalWithSlot from "../Elements/FullscreenModalWithSlot";
  import Vue from "vue";
  import {getStore} from "../graphql/queries";

  export default {
    name: "StoreDetails",
    data: () => ({
      overlay: false,
      clarifications_list: [
        {
          title: 'Max Visitors',
          text: 'Set the maximum amount of visitors allowed into the store at one time.'
        },
        {
          title: 'Visit Duration',
          text: 'Set the maximum duration of the visit per visitor.'
        },
        {
          title: 'Automated Exit',
          text: 'The automated exit capability is a failsafe elapsed time feature to maintain an efficient queue. It is deployed when a visitor has forgotten to scan their QR code when leaving after their visit. Set this time based off of the average visit time per visitor.'
        },
        {
          title: 'Code Expiration',
          text: 'Set the amount of time the visitor has to scan their QR code upon entrance before they are automatically timed out and their reservation is cancelled.'
        }
      ]
    }),
    components: {FullscreenModalWithSlot, FullScreenMap, SpotS3Image, StoreOpenTable, UsersList, StoreTile},
    computed: {

      ...mapGetters(['timezoneValues', 'loadingState', 'getStoreById', 'getBrandById', 'isBrandManagerOfStore']),
      getTimezoneNameByValue() {
        let timezone = this.timezoneValues.filter(zone => zone.value === this.store.timezone)
        return timezone[0].text
      },
      no_manager_text() {
        return `No ${this.brand.store_manager_role_title} on file`
      },
      no_security_text() {
        return `No ${this.brand.security_role_title} on file`
      },
      store() {
        return this.getStoreById(this.$route.params.store_id);
      },
      brand() {
        return this.getBrandById(this.store.brand_id);
      }
    },

    methods: {

      toggleOverlay() {
        this.overlay = !this.overlay
      },
      deleteStore() {
        var that = this;
        var store_id = that.store.id
        if (that.$route.name == PAGE_IDS.STORE_DETAILS) {
          this.$router.push({name: PAGE_IDS.STORES_LIST})
        }
        this.$store.dispatch('removeStore', store_id)
        this.$Amplify.API.graphql(this.$Amplify.graphqlOperation(doDeleteStore, {id: store_id}))
          .then((response) => {
          })
          .catch((e) => {
            Vue.prototype.$Amplify.API.graphql(Vue.prototype.$Amplify.graphqlOperation(getStore, {id: store_id}))
              .then((res) => {
                this.$store.dispatch('addStore', res.data.getStore)
              })
            process_api_error(`Error Deleting Store`, e)
          });
      },
      convert_to_time(time_in_minutes) {
        if (time_in_minutes == 24 * 60) {
          return '12:00 PM'
        }
        var ap = [' AM', ' PM']; // AM-PM
        var hh = Math.floor(time_in_minutes / 60); // getting hours of day in 0-24 format
        var mm = (time_in_minutes % 60); // getting minutes of the hour in 0-55 format
        var str = ("0" + (hh % 12)).slice(-2) + ':' + ("0" + mm).slice(-2) + ap[Math.floor(hh / 12)]; // pushing data in array in [00:00 - 12:00 AM/PM format]
        return str
      },
      updateStoreManagers(new_managers) {
        var input = {
          ...this.store,
          storemanagers: new_managers
        }
        this.$store.dispatch('updateStore', input)

        delete input['brand']
        delete input['createdAt']
        delete input['updatedAt']
        this.$Amplify.API.graphql(this.$Amplify.graphqlOperation(doUpdateStore, input))
          .then((res) => {
            this.$store.dispatch('updateStore', res.data.doUpdateStore)
          })
          .catch((e) => {
            Vue.prototype.$Amplify.API.graphql(Vue.prototype.$Amplify.graphqlOperation(getStore, {id: this.store.id}))
              .then((res) => {
                this.$store.dispatch('updateStore', res.data.getStore)
              })
            process_api_error(`Error updating Store`, e)
          });
      },
      updateStoreSecurity(new_security) {
        var input = {
          ...this.store,
          security: new_security
        }
        this.$store.dispatch('updateStore', input)
        delete input['brand']
        delete input['createdAt']
        delete input['updatedAt']
        this.$Amplify.API.graphql(this.$Amplify.graphqlOperation(doUpdateStore, input))
          .then((res) => {
            this.$store.dispatch('updateStore', res.data.doUpdateStore)
          })
          .catch((e) => {
                Vue.prototype.$Amplify.API.graphql(Vue.prototype.$Amplify.graphqlOperation(getStore, {id: this.store.id}))
              .then((res) => {
                this.$store.dispatch('updateStore', res.data.getStore)
              })
            process_api_error(`Error updating Store`, e)
          });
      }
    },
  }


</script>
<style lang="scss">


  .primary-gradient-background {
    align-items: center;
    text-align: center;
    justify-content: center;
    display: grid;
    grid-template-rows: auto 1rem auto;
    padding-top: 1rem;

    .brand-title {
      text-align: center;
      font-size: 18px;
      color: white;
      font-weight: 500;
    }

    .action-btns {
      .v-btn {
        margin: 0 .4rem;
        height: 32px;
        text-transform: none;
      }
    }
  }

  .general_info_val {
    font-weight: 600;
  }


  .store_details_container {
    display: grid;
    grid-row-gap: 1rem;
    grid-column-gap: 3rem;
    grid-template-columns: 1fr;


    @media screen and (max-width: 599px) {

    }
    @media screen and (max-width: 1024px) and (min-width: 600px) {
      grid-template-columns: 1fr 1fr;
      .spacer {
        grid-column-end: span 2;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/Stores/StoreDetails.vue